import React from 'react';
import styles from './LiveChatSessionInfoBubble.module.css';

export const LiveChatSessionInfoBubble: React.FC<{ children: any }> = ({
    children,
}) => {
    return (
        <div className={styles.liveChatSessionInfoBubble}>
            <div>{children}</div>
        </div>
    );
};
